<template>
  <div><img :src="src" /></div>
</template>

<script>
export default {
  name: 'progressive-img',
  props: {
    src: { type: String },
    placeholder: { type: String }
  }
};
</script>
